<modal-popup
  [flexible]="true"
  [focusOnOpen]="true"
  [alignLeft]="true"
  [isOpen]="true"
  (onClose)="close()"
  [title]="'translate.cat.createBoundingBoxAnchor' | translate"
>

<div class="container">
          <input-wrap label="{{ 'translate.anchors.anchor-path' | translate }}" cssClass="l-cell-spread">
            <input type="text" [(ngModel)]="anchorToCreate.embeddedObjectAnnotation.anchorPath" class="t-input l-cell-spread-x" [disabled]="anchorToCreate.refDocAnchorId != null" [readonly]="anchorToCreate.refDocAnchorId != null" />

          </input-wrap>
          <div *ngIf="anchorToCreate.refDocAnchorId != null && !isAlreadyAddedAnchor" class="displaying-error-message">
            {{ 'translate.anchors.anchor-already-exists' | translate }}
          </div>

          <div *ngIf="isAlreadyAddedAnchor" class="displaying-error-message">
            {{ 'translate.anchors.anchor-already-added' | translate }}
          </div>
          
    <div *ngIf="!isAlreadyAddedAnchor" class="t-panel-cell t-buttonSet l-align-end l-mar-top">
        <button
          (click)="save()"
          class="t-button-outline"
        >
          {{ "translate.general.save" | translate }}
        </button>
        <button
          (click)="close()"
          class="t-button-outline t-button-warn"
        >
          {{ "translate.general.discard" | translate }}
        </button>
        &nbsp;

      </div>
</div>


</modal-popup>